import { render, staticRenderFns } from "./ChangepwdMyntin.vue?vue&type=template&id=f9420078&"
import script from "./ChangepwdMyntin.vue?vue&type=script&lang=js&"
export * from "./ChangepwdMyntin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports